// extracted by mini-css-extract-plugin
export var button = "_jg-0";
export var donut = "_jg-1";
export var donutFill = "_jg-3";
export var donutTrack = "_jg-2";